export default {
    name: "version",
    data () {
        return{
            versionList: [
                {
                    thumb: '/img/payOverview/version1.png',
                    title: '营销优选版',
                    info: '轻量化、全自动的小店数字营销工具，轻松玩转营销活动，实现盈利增长。',
					tag: '10万小店点赞',
					tagColor: '#6370CE',
                    linkTxt: '一键升级',
                    linkHref: '/marketingVersion',
					linkType: 'router',
                },
				{
                    thumb: '/img/payOverview/version2.png',
                    title: '营销高级版',
                    info: '有效构建企业的“私域流量”能力，并打通“公转私”的闭环方案，为门店生意持续注入活力。',
					tag: '泛行业热门爆款',
					tagColor: '#FF451A',
                    linkTxt: '一键升级',
                    linkHref: '/advancedMarketing',
                    linkType: 'router',
				},
				{
                    thumb: '/img/payOverview/version3.png',
                    title: '商盟平台板',
                    info: '专为想要在区域自建“平台”型的服务商打造，将分散的商户整合形成商家联盟，联合运营，统一变现。',
					tag: '资源变现首选',
					tagColor: '#5CBCBC',
                    linkTxt: '一键升级',
                    linkHref: '/businessUnion',
                    linkType: 'router',
				},
				{
                    thumb: '/img/payOverview/version4.png',
                    title: '餐饮高级版',
                    info: '为餐饮商户提供包括收银、扫码点餐、商城、企业微信、企业钱包等全系列能力，全面赋能餐饮商户的数字化和营收增长。',
					tag: '餐饮全面一体化',
					tagColor: '#F5A416',
                    linkTxt: '一键升级',
                    linkHref: '/digitalizeRestaurant',
                    linkType: 'router',
				},
				{
                    thumb: '/img/payOverview/version5.png',
                    title: '零售高级版',
                    info: '为零售商户提供从收银支付、供应链、商品、财务、外卖、员工、私域会员等的闭环解决方案。全面赋能零售商户的数字化和营收增长。',
					tag: '连锁扩张必备',
					tagColor: '#001372',
                    linkTxt: '一键升级',
                    linkHref: '/digitalizeRetail',
                    linkType: 'router',
				},
				{
                    thumb: '/img/payOverview/version6.png',
                    title: '加油站高级版',
                    info: '为加油站提供数字收银、数字营销、数字管理、数字商城、智慧油站等于一体的全站式解决方案。助力油站真正实现降本、提效、增收。',
					tag: '上万油站推荐',
					tagColor: '#00C409',
                    linkTxt: '一键升级',
                    linkHref: '/gasStation',
                    linkType: 'router',
				},
            ]
        }
    }
};
